


















































































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import WidgetWrapper from '@/components/widgets/WidgetWrapper.vue';
import CreativeInfo from '@/components/campaign/creatives/CreativeInfo.vue';
import FieldCheckbox from '@/components/form/FieldCheckbox.vue';
import { Creative, EStatus } from '@/types';
import { chain } from 'lodash';
import { ICreative, ICreativeStatistics } from '@/types/campaign/creatives';
import { getIcon, TIconSvg } from '@/configs/iconsConfigs';
import CreativeService from '@/services/CreativeService';
import { getTranslate } from '@/helpers/translateHelpers';
import NotificationService from '@/services/NotificationService';

export default Vue.extend({
  name: 'TheCreatives',
  components: {
    WidgetWrapper,
    CreativeInfo,
    FieldCheckbox,
  },

  watch: {
    creativesStatisticData() {
      this.addStatisticsToCreatives();
    },
    moderateCreativesData() {
      this.addModerationsToCreatives();
    },
    campaignCreatives() {
      this.addStatisticsToCreatives();
      this.addModerationsToCreatives();
    },
  },

  computed: {
    ...mapGetters({
      allCreatives: 'campaignCreatives/getAllCreatives',
      moderateCreatives: 'campaignCreatives/getModerateCreatives',
      creativesStatistic: 'getCreativesStatistic',
      allCreativesHaveErrors: 'campaignCreatives/getAllCreativesHaveErrors',
    }),
    creativesStatisticData(): Array<ICreativeStatistics> {
      return this.creativesStatistic.data;
    },
    moderateCreativesData(): Array<Creative> {
      return this.moderateCreatives.data;
    },
    activeStatus(): string {
      return EStatus.ACTIVE;
    },
  },

  methods: {
    getIcon(iconName: string): TIconSvg {
      return getIcon(iconName);
    },
    addStatisticsToCreatives() {
      const statistics = chain(this.creativesStatisticData).keyBy('id').value();

      for (const id of this.allCreatives.allIds) {
        this.allCreatives.byId[id].statistics = statistics[id] ?? {};
      }
    },
    addModerationsToCreatives() {
      const moderations = chain(this.moderateCreativesData)
        .keyBy('id')
        .mapValues('ssp_moderate')
        .value();

      for (const id of this.allCreatives.allIds) {
        this.allCreatives.byId[id].sspModerate = moderations[id] ?? [];
      }
    },
    cloneCreative(creative: ICreative) {
      CreativeService.cloneCreative(creative);
      this.deselectCreatives();
    },
    editCreative(creative: ICreative) {
      CreativeService.editCreative(creative);
      this.deselectCreatives();
    },
    deleteCreative(creativeId: string) {
      this.$confirm({
        title: getTranslate('pages.campaigns.popup.title'),
        content: getTranslate('notifications.lostData'),
        cancelText: getTranslate('body.popup.buttons.no'),
        okText: getTranslate('body.popup.buttons.yes'),
      })
        .then(() => {
          CreativeService.deleteCreative(creativeId);

          const message = getTranslate('notifications.deleteCreative');
          NotificationService.confirmDelete(message);
          this.deselectCreatives();
        })
        .catch(() => {
          NotificationService.cancelDelete();
        });
    },
    editSelectedCreatives() {
      if (this.selectedCreatives.length) {
        for (const creativeId of this.selectedCreatives) {
          this.editCreative(this.allCreatives.byId[creativeId]);
        }

        this.deselectCreatives();
      }
    },
    deleteSelectCreatives() {
      if (this.selectedCreatives.length) {
        this.$confirm({
          title: getTranslate('pages.campaigns.popup.title'),
          content: getTranslate('notifications.lostData'),
          cancelText: getTranslate('body.popup.buttons.no'),
          okText: getTranslate('body.popup.buttons.yes'),
        })
          .then(() => {
            for (const creativeId of this.selectedCreatives) {
              CreativeService.deleteCreative(creativeId);
            }

            const message = getTranslate('notifications.deleteCreatives');
            NotificationService.confirmDelete(message);
            this.deselectCreatives();
          })
          .catch(() => {
            NotificationService.cancelDelete();
          });
      }
    },
    changeCreativeStatus(creative) {
      CreativeService.changeStatus(creative);
    },
    selectCreative(creativeId: string) {
      if (this.selectedCreatives.includes(creativeId)) {
        this.selectedCreatives = this.selectedCreatives.filter(
          (c) => c !== creativeId
        );
      } else {
        this.selectedCreatives.push(creativeId);
      }
    },
    selectAllCreatives() {
      if (this.selectedCreatives.length) {
        this.deselectCreatives();
      } else {
        this.selectedCreatives = [...this.allCreatives.allIds];
      }
    },
    deselectCreatives() {
      this.selectedCreatives = [];
    },
  },

  data() {
    return {
      selectedCreatives: [] as Array<string>,
    };
  },
});
